export type ClassName = string | undefined | null | false;

/**
 * A helper function that concatenates an array of class names into a single string.
 * It filters out any undefined, null, or false values from the array.
 *
 * @param classNameArray - An array of class names to be concatenated.
 * @returns A single string containing all valid class names separated by spaces.
 */
const classNamesHelper = (classNameArray: Array<ClassName>) => {
  let concatClassName = '';
  classNameArray.forEach((className: ClassName) => {
    if (className) {
      concatClassName += ` ${className}`;
    }
  });
  return concatClassName;
};

export default classNamesHelper;
